"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPaymentUpdateRequest = exports.transformPaymentRequest = exports.transformPaymentListResponse = exports.transformPaymentResponse = exports.PaymentType = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Money_1 = require("./Money");
const Error_1 = require("./Error");
const Date_1 = require("./Date");
var PaymentType;
(function (PaymentType) {
    PaymentType["Check"] = "Check";
    PaymentType["Credit"] = "Credit";
    PaymentType["Cash"] = "Cash";
    PaymentType["BankTransfer"] = "Bank Transfer";
    PaymentType["CreditCard"] = "Credit Card";
    PaymentType["Debit"] = "Debit";
    PaymentType["PayPal"] = "PayPal";
    PaymentType["TwoCheckout"] = "2Checkout";
    PaymentType["Visa"] = "VISA";
    PaymentType["Mastercard"] = "MASTERCARD";
    PaymentType["Discover"] = "DISCOVER";
    PaymentType["Amex"] = "AMEX";
    PaymentType["Diners"] = "DINERS";
    PaymentType["Jcb"] = "JCB";
    PaymentType["Ach"] = "ACH";
    PaymentType["Other"] = "Other";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
function transformPaymentResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { payment } = response.response.result;
    return transformPaymentParsedResponse(payment);
}
exports.transformPaymentResponse = transformPaymentResponse;
function transformPaymentListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { payments, per_page, total, page, pages } = response.response.result;
    return {
        payments: payments.map((payment) => transformPaymentParsedResponse(payment)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformPaymentListResponse = transformPaymentListResponse;
function transformPaymentParsedResponse(payment) {
    return {
        orderId: payment.orderid,
        accountingSystemId: payment.accounting_systemid,
        updated: (0, Date_1.transformDateResponse)(payment.updated, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        invoiceId: payment.invoiceid,
        creditId: payment.creditid,
        amount: (0, Money_1.transformMoneyParsedResponse)(payment.amount),
        clientId: payment.clientid,
        visState: payment.vis_state,
        logId: payment.logid,
        note: payment.note,
        overpaymentId: payment.overpaymentid,
        gateway: payment.gateway,
        date: (0, Date_1.transformDateResponse)(payment.date, Date_1.DateFormat['YYYY-MM-DD']),
        transactionId: payment.transactionid,
        fromCredit: payment.from_credit,
        type: payment.type,
        id: payment.id,
    };
}
function transformPaymentRequest(payment) {
    return JSON.stringify({
        payment: {
            amount: payment.amount && (0, Money_1.transformMoneyParsedRequest)(payment.amount),
            date: (0, Date_1.transformDateRequest)(payment.date),
            invoiceid: payment.invoiceId,
            note: payment.note,
            orderid: payment.orderId,
            transactionid: payment.transactionId,
            type: payment.type,
            vis_state: payment.visState,
        },
    });
}
exports.transformPaymentRequest = transformPaymentRequest;
function transformPaymentUpdateRequest(payment) {
    return JSON.stringify({
        payment: {
            amount: payment.amount && (0, Money_1.transformMoneyParsedRequest)(payment.amount),
            date: payment.date && (0, Date_1.transformDateRequest)(payment.date),
            note: payment.note,
            orderid: payment.orderId,
            transactionid: payment.transactionId,
            type: payment.type,
        },
    });
}
exports.transformPaymentUpdateRequest = transformPaymentUpdateRequest;
//# sourceMappingURL=Payment.js.map